import type { LoaderFunctionArgs } from "react-router";
import type { AppInfoResponse } from "src/queries/info/info.types";
import { fetchOutsideReact } from "src/utils/fetchOutsideReact";
import { queryClient } from "@utils/query-client.ts";

export const prefetchRouterLoader = async (
  _args: LoaderFunctionArgs
): Promise<boolean> => {
  const appInfo = await fetchOutsideReact<AppInfoResponse>({
    queryKey: ["/api/info"],
    url: "/api/info",
  });
  queryClient.setQueryData(["/api/info"], appInfo);

  return true;
};
